import { ApplicationNames } from './shared';
import envConfig from '../config/config';

const TRIALS_APP_ROLES = [
  'sundial-role:T_PATIENT_MATCHER',
  'sundial-role:T_TRIAL_MATCHER',
  'sundial-role:T_SITE_MANAGER',
];

export const trialsApplication = {
  name: ApplicationNames.TRIALS_APP,
  url: envConfig.apps.trialsApp,
  roles: TRIALS_APP_ROLES,
};
